export default {
  group: [
    {
      name: 'personal_data',
      fields: [
        {
          name: 'full_name',
          type: 'text',
          column_type: 'two-third-row',
        },
        {
          name: 'edrpou',
          type: 'text',
          column_type: 'one-third-row',
        },
      ],
    },
    {
      name: 'contact_data',
      fields: [
        {
          name: 'phone',
          type: 'text',
          mask: 'phone',
          column_type: 'one-third-row',
        },
        {
          name: 'working_email',
          type: 'text',
          mask: 'email',
          column_type: 'one-third-row',
        },
      ],
    },
  ],
};
